<template>
  <div class="profile-page">
    <section class="section-profile-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-ptwist shape-skew alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </section>
    <section class="section section-skew mt-3">
      <div class="container">
        <card shadow class="card-profile mt--300" no-body>
          <div class="px-4">
            <div class="row justify-content-center pb-5">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <a href="#">
                    <img src="@/assets/img/rss.png" class="rounded-circle">
                  </a>
                </div>
              </div>
              <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
                <div class="card-profile-actions py-4 mt-lg-0">
                </div>
              </div>
              <div class="col-lg-4 order-lg-1">
              </div>
            </div>
            <div class="text-center mt-5">
              <h3>RSS Feed
              </h3>
              <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>PlasticTwist Crowdsourcing RSS Feed
              </div>
            </div>
            <div class="mt-5 py-5 border-top pl-4 pr-4">
              <p>
                RSS (Really Simple Syndication) feeds offer another way to get the PlasticTwist Crowdsourcing content.
                Subscribe to our
                feeds to get the latest top tweets formatted for your
                favorite feed reader and updated every day. Click on the button below and add the link to your RSS
                reader.
              </p>
              <p class="text-center">
                <a href="https://ptwist.csd.auth.gr:20443/rss" target="_blank">

                  <base-button class="mr-2 mb-3 mb-sm-0"
                               type="orange">
                    RSS Feed XML
                  </base-button>
                </a>
              </p>
              <p class="mt-3">
                A simple guide of how to consume an RSS Fee can be found
                <a class="font-weight-bold"
                   href="http://rss-tutorial.com/rss-how-to-subscribe-to-feeds.php"
                   target="_blank">here</a>.
              </p>
            </div>
          </div>
        </card>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  components: {}
}
</script>
<style>
</style>
